const setupGAEvents = () => {
    // send GA events on sign out 
    document.querySelectorAll("a.sign-out").forEach(aTag => aTag.addEventListener("click", () => {
        gtag("event", "Sign Out", {
            "event_category": "Engagement",
            "event_label": ""
        });
    }));

    // send GA events on external dashboard links 
    document.querySelectorAll(".dashboard-container a.card.external-link").forEach(aTag => aTag.addEventListener("click", () => {
        gtag("event", "Outbound Link Click", {
            "event_category": "Engagement",
            "event_label": ""
        });
    }));
}

window.addEventListener('DOMContentLoaded', _ => {
    setupGAEvents();
});